export default __webpack_public_path__ + "static/media/icon-studies.121ac627.svg";